<!-- メニュー -->
<app-menu></app-menu>

<!-- メイン -->
<div class="main">
  <!-- メインコンテンツ -->
  <div class="main-content" [class.platform-large-text]="getTextSize()">
    <!-- A100系共通部品_Steps -->
    <app-c100-steps></app-c100-steps>

    <!-- タイトル -->
    <div class="title">
      <h1>
        <label *ngIf="!confirmationFlag && 1 == agendaKbn"> 課題登録</label>
        <label *ngIf="!confirmationFlag && 2 == agendaKbn">
          ソリューション登録
        </label>
        <label *ngIf="confirmationFlag">登録内容確認</label>
      </h1>
    </div>

    <!-- 課題・ソリューション登録(C101) -->
    <div *ngIf="!confirmationFlag">
      <!-- 入力フォーム -->
      <form [formGroup]="c101InputForm">
        <!-- 課題・ソリューション情報 -->
        <div class="task-information">
          <!-- 備考 -->
          <div class="note">
            <label>
              以下の項目に必要事項をご記載後、「確認画面へ進む」ボタンをクリックしてください。<br />
              <label class="warning"
                >【必須】の項目は入力必須項目です。必ずご記載ください。
              </label>
              <br />
              運営事務局の承認後に一般公開となります。項目毎の公開、非公開は以下の凡例をご参照ください。<br />
            </label>
            <!-- 公開 -->
            <p-tag value="公開" styleClass="public-tag"></p-tag>
            …一般公開(ウェブサイト上で公開します)<br />
            <!-- 非公開 -->
            <p-tag value="非公開" styleClass="private-tag"></p-tag>
            …公開しません
          </div>

          <!-- 事務局代行登録 -->
          <div *ngIf="decisionSecretariat() && existAlternateUser()">
            <div class="task-title">
              <h1>事務局登録項目</h1>
            </div>
            <p-table [value]="[{}]" styleClass="information-Form">
              <ng-template pTemplate="body">
                <tr>
                  <td class="item-input-name">
                    課題所有団体
                    <span class="required">【必須】</span>
                  </td>
                  <td class="item-label-name">
                    <p-tag value="公開" styleClass="public-tag"></p-tag>
                  </td>
                  <td class="item-information">
                    {{ alternateUser.organization_name }}
                  </td>
                </tr>
              </ng-template>
            </p-table>
            <div class="task-title">
              <h1>課題内容</h1>
            </div>
          </div>
          <!-- 課題・ソリューション内容 -->
          <p-table [value]="[{}]" styleClass="information-Form">
            <ng-template pTemplate="body">
              <!-- タイトル -->
              <tr>
                <td class="item-input-name">
                  タイトル
                  <span class="required">【必須】</span>
                </td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <div class="warning-text">
                    ※貴団体の

                    <label *ngIf="1 == agendaKbn">
                      課題タイトルを
                      <label class="warning">50字</label>
                    </label>
                    <label *ngIf="2 == agendaKbn">
                      ソリューションタイトルを
                      <label class="warning">50字</label>
                    </label>
                    以内でご記載ください
                  </div>
                  <input
                    type="text"
                    pInputText
                    class="information-Form-inputtext-wMax"
                    formControlName="title"
                  />
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="c101InputForm.get('title')">
                  </app-validator-message>
                </td>
              </tr>

              <!-- カテゴリ -->
              <tr>
                <td class="item-input-name">
                  カテゴリ
                  <span class="required">【必須】</span><br />
                  ※最大３つまで選択可
                </td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information multi-line">
                  <!-- <div class="warning-text">
                    <label *ngIf="1 == agendaKbn">
                      本課題のカテゴリを
                      <label class="warning">最大3つ</label>
                      まで選択してください。
                    </label>
                    <label *ngIf="2 == agendaKbn">
                      貴団体のソリューションの組み込みカテゴリを以下から
                      <label class="warning">最大3つ</label>
                      まで選択してください。
                    </label>
                  </div> -->
                  <div
                    class="two-line-content"
                    *ngFor="let category of categoryList"
                  >
                    <!-- カテゴリ大項目 -->
                    {{ category.class_name1 }}
                    <!-- カテゴリ中項目 -->
                    <div
                      class="category-checkbox"
                      *ngFor="let list of category.rec"
                    >
                      <p-checkbox
                        [label]="list.class_name2"
                        [value]="list.value"
                        [formControl]="c101InputForm.controls.category"
                      ></p-checkbox>
                    </div>
                  </div>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message
                    [control]="c101InputForm.get('category')"
                  >
                  </app-validator-message>
                </td>
              </tr>
              <!-- 解決したい課題内容 -->
              <tr *ngIf="1 == agendaKbn">
                <td class="item-input-name">
                  解決したい課題内容<span class="required">【必須】</span>
                </td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <div class="warning-text">
                    ※解決したい課題の内容を、
                    <label class="warning">400字</label>
                    以内でご記載ください
                  </div>
                  <textarea
                    pInputTextarea
                    class="information-Form-inputtext-wMax p-text-area-400"
                    formControlName="agenda"
                  ></textarea>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message
                    [control]="c101InputForm.get('agenda')"
                  >
                  </app-validator-message>
                </td>
              </tr>
              <!-- 図・写真 -->
              <tr *ngIf="1 == agendaKbn">
                <td class="item-input-name">図・写真</td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <div class="warning-text">
                    ※課題の補足情報として、
                    <label class="warning">5MB</label>
                    以下の図又は写真が添付可能です。
                  </div>
                  <p-fileUpload
                    #image
                    [chooseLabel]="'ファイルを選択'"
                    [cancelLabel]="'キャンセル'"
                    [showUploadButton]="false"
                    fileLimit="1"
                    (onSelect)="uploadFile($event, image, 'image')"
                    (onRemove)="deleteFile('image')"
                    (onClear)="deleteFile('image')"
                  >
                    <ng-template pTemplate="content">
                      <div
                        class="p-fileupload-files ng-star-inserted"
                        *ngIf="caseImgId"
                      >
                        <div class="ng-star-inserted">
                          <div class="p-fileupload-row ng-star-inserted">
                            <div class="image">
                              <img
                                [src]="searchResultsList.image.file_path"
                                width="50"
                                class="ng-star-inserted"
                                alt="image"
                              />
                            </div>
                            <div>{{ searchResultsList.image.name }}</div>
                            <div></div>
                            <div>
                              <button
                                type="button"
                                icon="pi pi-times"
                                pbutton=""
                                ng-reflect-icon="pi pi-times"
                                class="p-button p-component p-button-icon-only"
                                (click)="deleteFile('image')"
                              >
                                <span
                                  class="p-button-icon pi pi-times"
                                  aria-hidden="true"
                                ></span>
                                <span aria-hidden="true" class="p-button-label"
                                  >&nbsp;</span
                                >
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="p-fileupload-files ng-star-inserted"
                        *ngIf="
                          !caseImgId &&
                          retouchFlg &&
                          file_path?.length != 0 && file_path != undefined
                        "
                      >
                        <div class="ng-star-inserted">
                          <div class="p-fileupload-row ng-star-inserted">
                            <div class="image">
                              <img
                                [src]="file_path"
                                width="50"
                                class="ng-star-inserted"
                                alt="image"
                              />
                            </div>
                            <div>{{ file_name }}</div>
                            <div></div>
                            <div>
                              <button
                                type="button"
                                icon="pi pi-times"
                                pbutton=""
                                ng-reflect-icon="pi pi-times"
                                class="p-button p-component p-button-icon-only"
                                (click)="deleteFile('image')"
                              >
                                <span
                                  class="p-button-icon pi pi-times"
                                  aria-hidden="true"
                                ></span>
                                <span aria-hidden="true" class="p-button-label"
                                  >&nbsp;</span
                                >
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </ng-template>
                  </p-fileUpload>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message
                    [control]="c101InputForm.get('image')"
                  ></app-validator-message>
                </td>
              </tr>
              <!-- 課題に対する現在の取り組み -->
              <tr *ngIf="1 == agendaKbn">
                <td class="item-input-name">
                  課題に対する現在の取組<span class="required">【必須】</span>
                </td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <div class="warning-text">
                    ※課題に対する現在の取組内容を、
                    <label class="warning">400字</label>
                    以内でご記載ください
                  </div>
                  <textarea
                    pInputTextarea
                    class="information-Form-inputtext-wMax p-text-area-400"
                    formControlName="measures"
                  ></textarea>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message
                    [control]="c101InputForm.get('measures')"
                  >
                  </app-validator-message>
                </td>
              </tr>
              <!-- 提案者側に期待すること -->
              <tr *ngIf="1 == agendaKbn">
                <td class="item-input-name">
                  提案者側に期待すること<span class="required">【必須】</span>
                </td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <div class="warning-text">
                    ※提案者へ期待することを、
                    <label class="warning">400字</label>
                    以内でご記載ください
                  </div>
                  <textarea
                    pInputTextarea
                    class="information-Form-inputtext-wMax p-text-area-400"
                    formControlName="expectations"
                  ></textarea>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message
                    [control]="c101InputForm.get('expectations')"
                  >
                  </app-validator-message>
                </td>
              </tr>
              <!-- 定量的な目標値があれば記載してください -->
              <tr *ngIf="1 == agendaKbn">
                <td class="item-input-name">定量的な目標値</td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <div class="warning-text">
                    ※定量的な目標値を、
                    <label class="warning">400字</label>
                    以内でご記載ください
                  </div>
                  <textarea
                    pInputTextarea
                    class="information-Form-inputtext-wMax p-text-area-400"
                    formControlName="target"
                  ></textarea>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message
                    [control]="c101InputForm.get('target')"
                  >
                  </app-validator-message>
                </td>
              </tr>
              <!-- 現時点の予算状況 -->
              <tr *ngIf="1 == agendaKbn">
                <td class="item-input-name">
                  現時点の予算状況<span class="required">【必須】</span>
                </td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <div class="warning-text">
                    ※現時点の状況を選択してください。
                  </div>
                  <p-dropdown
                    [options]="getDicList(2021)"
                    optionLabel="sp_name"
                    optionValue="sp_code"
                    placeholder="選択してください"
                    [showClear]="true"
                    styleClass="information-Form-dropdown"
                    formControlName="budget"
                  ></p-dropdown>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message
                    [control]="c101InputForm.get('budget')"
                  ></app-validator-message>
                  <div class="warning-text">
                    ※コメント欄：予算状況に関する補足情報等を
                    <label class="warning">100字</label>
                    以内でご記載ください
                  </div>
                  <textarea
                    pInputTextarea
                    class="information-Form-inputtext-wMax p-text-area-100"
                    formControlName="budget_note"
                  ></textarea>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message
                    [control]="c101InputForm.get('budget_note')"
                  ></app-validator-message>
                </td>
              </tr>
              <!-- 予算化の方法 -->
              <tr *ngIf="1 == agendaKbn">
                <td class="item-input-name">予算化の方法</td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <div class="warning-text">
                    ※課題解決への取組に活用可能な予算の準備等について
                    <label class="warning">200字</label>
                    以内でご記載ください
                  </div>
                  <textarea
                    pInputTextarea
                    placeholder="予算化の方法を記載頂くことで、提案内容の具体性向上に繋がります。&#13;&#10;例）経費として予算編成/ 臨時交付金・補助金/ 活用可能な制度（ふるさと納税、クラウドファンディング、ソーシャルインパクトボンド、ベンチャーキャピタル　等）"
                    class="information-Form-inputtext-wMax textarea-budget-method"
                    formControlName="budget_method"
                  ></textarea>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message
                    [control]="c101InputForm.get('budget_method')"
                  ></app-validator-message>
                </td>
              </tr>
              <!-- ソリューション内容 -->
              <tr *ngIf="2 == agendaKbn">
                <td class="item-input-name">
                  ソリューション内容<span class="required">【必須】</span>
                </td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <div class="warning-text">
                    ※ソリューションの内容を
                    <label class="warning">400字</label>
                    以内でご記載ください
                  </div>
                  <textarea
                    pInputTextarea
                    class="information-Form-inputtext-wMax p-text-area2-400"
                    formControlName="solution_detail"
                  ></textarea>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message
                    [control]="c101InputForm.get('solution_detail')"
                  >
                  </app-validator-message>
                </td>
              </tr>
              <!-- 図・写真 -->
              <tr *ngIf="2 == agendaKbn">
                <td class="item-input-name">図・写真</td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <div class="warning-text">
                    ※課題の補足情報として、
                    <label class="warning">5MB</label>
                    以下の図又は写真が添付可能です。
                  </div>
                  <p-fileUpload
                    #image
                    [chooseLabel]="'ファイルを選択'"
                    [cancelLabel]="'キャンセル'"
                    [showUploadButton]="false"
                    fileLimit="1"
                    (onSelect)="uploadFile($event, image, 'image')"
                    (onRemove)="deleteFile('image')"
                    (onClear)="deleteFile('image')"
                  >
                    <ng-template pTemplate="content">
                      <div
                        class="p-fileupload-files ng-star-inserted"
                        *ngIf="caseImgId"
                      >
                        <div class="ng-star-inserted">
                          <div class="p-fileupload-row ng-star-inserted">
                            <div class="image">
                              <img
                                [src]="searchResultsList.image.file_path"
                                width="50"
                                class="ng-star-inserted"
                                alt="image"
                              />
                            </div>
                            <div>{{ searchResultsList.image.name }}</div>
                            <div></div>
                            <div>
                              <button
                                type="button"
                                icon="pi pi-times"
                                pbutton=""
                                ng-reflect-icon="pi pi-times"
                                class="p-button p-component p-button-icon-only"
                                (click)="deleteFile('image')"
                              >
                                <span
                                  class="p-button-icon pi pi-times"
                                  aria-hidden="true"
                                ></span>
                                <span aria-hidden="true" class="p-button-label"
                                  >&nbsp;</span
                                >
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="p-fileupload-files ng-star-inserted"
                        *ngIf="
                          !caseImgId &&
                          retouchFlg &&
                          file_path?.length != 0 && file_path != undefined
                        "
                      >
                        <div class="ng-star-inserted">
                          <div class="p-fileupload-row ng-star-inserted">
                            <div class="image">
                              <img
                                [src]="file_path"
                                width="50"
                                class="ng-star-inserted"
                                alt="image"
                              />
                            </div>
                            <div>{{ file_name }}</div>
                            <div></div>
                            <div>
                              <button
                                type="button"
                                icon="pi pi-times"
                                pbutton=""
                                ng-reflect-icon="pi pi-times"
                                class="p-button p-component p-button-icon-only"
                                (click)="deleteFile('image')"
                              >
                                <span
                                  class="p-button-icon pi pi-times"
                                  aria-hidden="true"
                                ></span>
                                <span aria-hidden="true" class="p-button-label"
                                  >&nbsp;</span
                                >
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </ng-template>
                  </p-fileUpload>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message
                    [control]="c101InputForm.get('image')"
                  ></app-validator-message>
                </td>
              </tr>
              <!-- 連携希望先 -->
              <tr *ngIf="2 == agendaKbn">
                <td class="item-input-name">
                  連携希望先<span class="required">【必須】</span>
                </td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  ※複数選択可
                  <div *ngFor="let dicData of getDicList(1)">
                    <p-checkbox
                      name="10"
                      [label]="dicData.sp_name"
                      [value]="dicData.sp_code"
                      [formControl]="c101InputForm.controls['image_group']"
                    ></p-checkbox>
                  </div>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message
                    [control]="c101InputForm.get('image_group')"
                  >
                  </app-validator-message>
                </td>
              </tr>
              <!-- 目指すSDGsゴール -->
              <tr>
                <td class="item-input-name">
                  目指すSDGsゴール<span class="required">【必須】</span>
                </td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  目指すSDGsゴールの番号を選択ください。<br />
                  （複数選択可）
                  <div class="multi-line">
                    <div
                      class="p-d-flex p-as-center checkbox-list two-line-content"
                      *ngFor="let dicData of getDicList(3)"
                    >
                      <p-checkbox
                        name="10"
                        [value]="dicData.sp_code"
                        [formControl]="c101InputForm.controls['sdgs_goal']"
                      >
                      </p-checkbox>
                      <div class="checkbox-img">
                        <img [src]="dicData.sp_ext" />
                      </div>
                      <div class="p-as-center">
                        {{ dicData.sp_code + "　" + dicData.sp_name }}
                      </div>
                    </div>
                  </div>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message
                    [control]="c101InputForm.get('sdgs_goal')"
                  >
                  </app-validator-message>
                </td>
              </tr>
              <!-- webサイト掲載終了日 -->
              <tr>
                <td class="item-input-name">
                  掲載終了日<span class="required">【必須】</span>
                </td>
                <td class="item-label-name"></td>
                <td class="item-information">
                  <div class="warning-text" *ngIf="1 == agendaKbn">
                    設定した終了日の翌日から提案の募集受付は終了となります。<br />
                    提案受付終了後もデータは残ります。
                  </div>
                  <div class="warning-text" *ngIf="2 == agendaKbn">
                    設定した終了日の翌日から非表示となります。<br />
                    掲載終了後もデータは残ります。掲載終了日を変更することで、再公開することができます。
                  </div>
                  <p-calendar
                    [showIcon]="true"
                    [yearNavigator]="true"
                    [monthNavigator]="true"
                    placeholder="例）2023/03/31"
                    dateFormat="yy/mm/dd"
                    dataType="string"
                    appendTo="body"
                    yearRange="2000:2999"
                    formControlName="end_date"
                    translate
                  ></p-calendar>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message
                    [control]="c101InputForm.get('end_date')"
                  >
                  </app-validator-message>
                </td>
              </tr>
              <!-- 公開掲示板の設定 -->
              <tr>
                <td class="item-input-name">
                  公開掲示板の設定<span class="required">【必須】</span>
                </td>
                <td class="item-label-name"></td>
                <td class="item-information">
                  <div class="warning-text">
                    本課題に掲示板を設定することができます。<br />
                    掲示板への書き込み・閲覧は全プラットフォーム会員が行うことができます。
                  </div>
                  <p-dropdown
                    [options]="getDicList(701)"
                    optionLabel="sp_name"
                    optionValue="sp_code"
                    placeholder="選択してください"
                    [showClear]="true"
                    styleClass="information-Form-dropdown"
                    formControlName="board_open"
                  ></p-dropdown>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message
                    [control]="c101InputForm.get('board_open')"
                  >
                  </app-validator-message>
                </td>
              </tr>
              <!-- ソリューション紹介WebサイトURL -->
              <tr *ngIf="2 == agendaKbn">
                <td class="item-input-name">
                  ソリューション紹介<br />ウェブサイトURL
                </td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <input
                    type="text"
                    pInputText
                    placeholder="例）https://future-city.go.jp/platform/"
                    class="information-Form-inputtext-wMax"
                    formControlName="solution_url"
                  />
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message
                    [control]="c101InputForm.get('solution_url')"
                  >
                  </app-validator-message>
                </td>
              </tr>
              <!-- ソリューション補足 -->
              <tr *ngIf="2 == agendaKbn">
                <td class="item-input-name">ソリューション補足</td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <textarea
                    pInputTextarea
                    class="information-Form-inputtext-wMax p-text-area2-400"
                    formControlName="solution_note"
                  ></textarea>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message
                    [control]="c101InputForm.get('solution_note')"
                  >
                  </app-validator-message>
                </td>
              </tr>
              <!-- 導入費用等の情報 -->
              <tr *ngIf="2 == agendaKbn">
                <td class="item-input-name">導入費用等の情報</td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <div class="warning-text">
                    ※ソリューション導入・検証等に必要な概要費用等を
                    <label class="warning">200字</label>
                    以内でご記載ください
                  </div>
                  <textarea
                    pInputTextarea
                    placeholder="導入費用を記載頂くことで、連携先団体にて必要な予算準備の検討等に役立ち、意見交換が円滑に進む場合があります。&#13;&#10;例）&#13;&#10;○○ヶ月の期間限定実証実験は無償としております。&#13;&#10;○○ヶ月で約○○万円より承っております。&#13;&#10;導入後年間費用○○万円～○○万円が目安です。条件によって費用が異なる場合がございます。詳細はご相談ください。"
                    class="textarea-introcost-info"
                    formControlName="introcost_info"
                  ></textarea>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message
                    [control]="c101InputForm.get('introcost_info')"
                  ></app-validator-message>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </form>

      <!-- ヴァリデーションチェックメッセージエリア -->
      <div class="p-d-flex p-jc-center error-area" *ngIf="!c101InputForm.valid">
        <label class="warning platform-warning-text">
          未入力の項目、またはエラーがあります。
        </label>
      </div>
      <!-- エラーがない場合のボタン位置統一用 -->
      <div class="p-d-flex p-jc-center error-area" *ngIf="c101InputForm.valid">
        <label class="warning platform-warning-text"> &nbsp; </label>
      </div>

      <!-- ボタンエリア -->
      <div class="p-d-flex p-jc-center button-area">
        <button
          pButton
          type="button"
          label="確認画面へ進む"
          class="button-default-size button1"
          (click)="moveC102()"
          [disabled]="!c101InputForm.valid"
        ></button>
      </div>
    </div>

    <!------------------------------------------------------------------------->

    <!-- 課題・ソリューション登録確認(C102) -->
    <div *ngIf="confirmationFlag">
      <!-- 課題・ソリューション情報 -->
      <div class="task-information">
        <!-- 備考 -->
        <div class="note">
          下記内容でよろしければ、「登録・更新する」ボタンを押してください。
          登録はせずに入力内容を保持する場合、「一時保存」ボタンを押してください。
        </div>

        <!-- 事務局代行登録 -->
        <div *ngIf="decisionSecretariat() && existAlternateUser()">
          <div class="task-title">
            <h1>事務局登録項目</h1>
          </div>
          <p-table [value]="[{}]" styleClass="information-Form">
            <ng-template pTemplate="body">
              <tr>
                <td class="item-input-name">
                  課題所有団体
                  <span class="required">【必須】</span>
                </td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  {{ alternateUser.organization_name }}
                </td>
              </tr>
            </ng-template>
          </p-table>
          <div class="task-title">
            <h1>課題内容</h1>
          </div>
        </div>
        <!-- 課題・ソリューション内容 -->
        <p-table [value]="[{}]" styleClass="information-Form">
          <ng-template pTemplate="body">
            <!-- タイトル -->
            <tr>
              <td class="item-input-name">
                タイトル
                <span class="required">【必須】</span>
              </td>
              <td class="item-label-name">
                <p-tag value="公開" styleClass="public-tag"></p-tag>
              </td>
              <td class="item-information">
                {{ c101InputForm.value.title }}
              </td>
            </tr>

            <!-- カテゴリ -->
            <tr>
              <td class="item-input-name">
                カテゴリ
                <span class="required">【必須】</span>
              </td>
              <td class="item-label-name">
                <p-tag value="公開" styleClass="public-tag"></p-tag>
              </td>
              <td class="item-information">
                <div
                  *ngFor="
                    let category of getClassNameList(
                      c101InputForm.value.category
                    )
                  "
                >
                  {{ category.class_name2 }}
                </div>
              </td>
            </tr>
            <!-- 解決したい課題内容 -->
            <tr *ngIf="1 == agendaKbn">
              <td class="item-input-name">
                解決したい課題内容<span class="required">【必須】</span>
              </td>
              <td class="item-label-name">
                <p-tag value="公開" styleClass="public-tag"></p-tag>
              </td>
              <td class="item-information">
                {{ c101InputForm.value.agenda }}
                <!-- 図・写真 -->
                <div
                  class="view-content"
                  *ngIf="file_path?.length != 0 && file_path != undefined"
                >
                  <img [src]="file_path" alt="image" id="image" />
                </div>
              </td>
            </tr>
            <!-- 課題に対する現在の取り組み -->
            <tr *ngIf="1 == agendaKbn">
              <td class="item-input-name">
                課題に対する現在の取組<span class="required">【必須】</span>
              </td>
              <td class="item-label-name">
                <p-tag value="公開" styleClass="public-tag"></p-tag>
              </td>
              <td class="item-information">
                {{ c101InputForm.value.measures }}
              </td>
            </tr>
            <!-- 提案者側に期待すること -->
            <tr *ngIf="1 == agendaKbn">
              <td class="item-input-name">
                提案者側に期待すること<span class="required">【必須】</span>
              </td>
              <td class="item-label-name">
                <p-tag value="公開" styleClass="public-tag"></p-tag>
              </td>
              <td class="item-information">
                {{ c101InputForm.value.expectations }}
              </td>
            </tr>
            <!-- 定量的な目標値があれば記載してください -->
            <tr *ngIf="1 == agendaKbn">
              <td class="item-input-name">定量的な目標値</td>
              <td class="item-label-name">
                <p-tag value="公開" styleClass="public-tag"></p-tag>
              </td>
              <td class="item-information">
                {{ c101InputForm.value.target }}
              </td>
            </tr>
            <!-- 現時点の予算状況 -->
            <tr *ngIf="1 == agendaKbn">
              <td class="item-input-name">現時点の予算状況</td>
              <td class="item-label-name">
                <p-tag value="公開" styleClass="public-tag"></p-tag>
              </td>
              <td class="item-information">
                <div>{{ getDicName(2021, c101InputForm.value.budget) }}</div>
                <div>{{ c101InputForm.value.budget_note }}</div>
              </td>
            </tr>
            <!-- 予算化の方法 -->
            <tr *ngIf="1 == agendaKbn">
              <td class="item-input-name">予算化の方法</td>
              <td class="item-label-name">
                <p-tag value="公開" styleClass="public-tag"></p-tag>
              </td>
              <td class="item-information">
                {{ c101InputForm.value.budget_method }}
              </td>
            </tr>
            <!-- ソリューション内容 -->
            <tr *ngIf="2 == agendaKbn">
              <td class="item-input-name">
                ソリューション内容<span class="required">【必須】</span>
              </td>
              <td class="item-label-name">
                <p-tag value="公開" styleClass="public-tag"></p-tag>
              </td>
              <td class="item-information">
                {{ c101InputForm.value.solution_detail }}
                <!-- 図・写真 -->
                <div
                  class="view-content"
                  *ngIf="file_path?.length != 0 && file_path != undefined"
                >
                  <img [src]="file_path" alt="image" id="image" />
                </div>
              </td>
            </tr>
            <!-- 連携希望先 -->
            <tr *ngIf="2 == agendaKbn">
              <td class="item-input-name">
                連携希望先<span class="required">【必須】</span>
              </td>
              <td class="item-label-name">
                <p-tag value="公開" styleClass="public-tag"></p-tag>
              </td>
              <td class="item-information">
                <div
                  *ngFor="
                    let dicName of getDicNameList(
                      1,
                      c101InputForm.value.image_group
                    )
                  "
                >
                  {{ dicName.sp_name }}
                </div>
              </td>
            </tr>
            <!-- 目指すSDGsゴール -->
            <tr>
              <td class="item-input-name">
                目指すSDGsゴール<span class="required">【必須】</span>
              </td>
              <td class="item-label-name">
                <p-tag value="公開" styleClass="public-tag"></p-tag>
              </td>
              <td class="item-information">
                <div
                  class="p-d-flex p-as-center checkbox-list"
                  *ngFor="
                    let dicName of getDicNameList(
                      3,
                      c101InputForm.value.sdgs_goal
                    )
                  "
                >
                  <div class="checkbox-img">
                    <img [src]="dicName.sp_ext" />
                  </div>
                  <div class="p-as-center">
                    {{ dicName.sp_code }}　{{ dicName.sp_name }}
                  </div>
                </div>
              </td>
            </tr>
            <!-- webサイト掲載終了日 -->
            <tr>
              <td class="item-input-name">
                掲載終了日<span class="required">【必須】</span>
              </td>
              <td class="item-label-name"></td>
              <td class="item-information">
                {{ c101InputForm.value.end_date }}
              </td>
            </tr>
            <!-- 公開掲示板の設定 -->
            <tr>
              <td class="item-input-name">
                公開掲示板の設定<span class="required">【必須】</span>
              </td>
              <td class="item-label-name"></td>
              <td class="item-information">
                {{ getDicName(701, c101InputForm.value.board_open) }}
              </td>
            </tr>
            <!-- ソリューション紹介WebサイトURL -->
            <tr *ngIf="2 == agendaKbn">
              <td class="item-input-name">
                ソリューション紹介<br />ウェブサイトURL
              </td>
              <td class="item-label-name">
                <p-tag value="公開" styleClass="public-tag"></p-tag>
              </td>
              <td class="item-information">
                {{ c101InputForm.value.solution_url }}
              </td>
            </tr>
            <!-- ソリューション補足 -->
            <tr *ngIf="2 == agendaKbn">
              <td class="item-input-name">ソリューション補足</td>
              <td class="item-label-name">
                <p-tag value="公開" styleClass="public-tag"></p-tag>
              </td>
              <td class="item-information">
                {{ c101InputForm.value.solution_note }}
              </td>
            </tr>
            <!-- 導入費用等の情報 -->
            <tr *ngIf="2 == agendaKbn">
              <td class="item-input-name">導入費用等の情報</td>
              <td class="item-label-name">
                <p-tag value="公開" styleClass="public-tag"></p-tag>
              </td>
              <td class="item-information">
                {{ c101InputForm.value.introcost_info }}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>

      <!-- ボタンエリア -->
      <div class="button-area">
        <div class="p-d-flex p-jc-center button-middle-area">
          <button
            pButton
            type="button"
            label="画面を印刷する"
            class="button2 little-button"
            (click)="print()"
          ></button>
          <button
            pButton
            type="button"
            label="一時保存"
            class="button4 little-button"
            (click)="moveC103(0)"
          ></button>
        </div>
        <div class="p-d-flex p-jc-center button-middle-area">
          <button
            pButton
            type="button"
            label="登録・更新する"
            class="button-default-size button1"
            (click)="moveC103(1)"
          ></button>
          <button
            pButton
            type="button"
            label="修正する"
            class="button-default-size button2"
            (click)="moveC101()"
          ></button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- フッダー -->
<footer>
  <app-footer></app-footer>
</footer>
